import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box } from "@vk-hr-tek/ui/Box";
import { Grid } from "@vk-hr-tek/ui/Grid";
import { InfoBox } from "@vk-hr-tek/ui/InfoBox";
import { Typography } from "@vk-hr-tek/ui/Typography";
import { FileInput } from "@vk-hr-tek/ui/input";
import { composeValidators } from "../validation/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const DEFAULT_MULTIPLE_ERRORS_TEXT = 'Некорректные данные. Исправьте ошибку в файле и загрузите повторно';
const parseUploadError = (error, multipleErrorsText)=>{
    const errorDetails = error.errorDetails;
    if (errorDetails) {
        const parts = errorDetails.split('\n').map((part)=>part.trim()).filter(Boolean);
        if (parts.length > 1) return {
            parsedErrorText: multipleErrorsText,
            parsedErrors: parts
        };
        if (1 === parts.length) return {
            parsedErrorText: parts[0],
            parsedErrors: []
        };
    }
    const info = error.info;
    return {
        parsedErrorText: 'string' == typeof info ? info : '',
        parsedErrors: []
    };
};
const CsvInput = ({ onUpload, onUploaded, onCleared, label, placeholder, tooltip, validate, errorBoxTitle = (count)=>`Ошибки в файле (${count})`, multipleErrorsText = DEFAULT_MULTIPLE_ERRORS_TEXT, fullWidth, disabled })=>{
    const [fileValue, setFileValue] = useState();
    const [errors, setErrors] = useState([]);
    const [errorText, setErrorText] = useState('');
    const [loading, setLoading] = useState(false);
    const validators = composeValidators(validate || []);
    const resetErrors = ()=>{
        setErrors([]);
        setErrorText('');
    };
    const handleChange = (file)=>_async_to_generator(function*() {
            resetErrors();
            setFileValue(file);
            if (!file) return void onCleared();
            setLoading(true);
            try {
                const uploadedIds = yield onUpload(file.value);
                onUploaded(uploadedIds);
                setErrorText('');
            } catch (uploadError) {
                const { parsedErrorText, parsedErrors } = parseUploadError(uploadError, multipleErrorsText);
                setErrors(parsedErrors);
                setErrorText(parsedErrorText);
            } finally{
                setLoading(false);
            }
        })();
    return /*#__PURE__*/ jsxs(Grid, {
        container: true,
        spacing: "24",
        children: [
            /*#__PURE__*/ jsx(Grid, {
                item: true,
                xs: 12,
                md: 9,
                children: /*#__PURE__*/ jsx(Box, {
                    mb: "-16",
                    children: /*#__PURE__*/ jsx(FileInput, {
                        label: label,
                        required: true,
                        loading: loading,
                        value: fileValue,
                        error: !!errorText,
                        errorText: errorText,
                        onChange: handleChange,
                        placeholder: placeholder,
                        fullWidth: fullWidth,
                        disabled: disabled,
                        validators: validators,
                        tooltip: tooltip
                    })
                })
            }),
            errors.length > 0 && /*#__PURE__*/ jsx(Grid, {
                item: true,
                xs: 12,
                md: 6,
                children: /*#__PURE__*/ jsx(InfoBox, {
                    title: errorBoxTitle(errors.length),
                    showIcon: true,
                    children: /*#__PURE__*/ jsx(Box, {
                        display: "flex",
                        flexDirection: "column",
                        rowGap: 1,
                        children: errors.map((item)=>/*#__PURE__*/ jsx(Typography, {
                                variant: "body3",
                                color: "text.light.tertirary",
                                children: item
                            }, item))
                    })
                })
            })
        ]
    });
};
export { CsvInput };
